export const questionTypes = {
  Choice: 'Choice',
  TFTest: 'TFTest',
  Assay: 'Assay'
}
